import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Paper,
  TextField,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { MAIN_URL } from "../../../Configurations/Urls";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import axios from "axios";
import toast from "react-hot-toast";
import Header from "../../DataLayouts/Header";

function ProjectTaskTypeForm({ mode: modeProp }) {

  const navigate = useNavigate();
  const { id } = useParams(); // if id is present => edit mode
  const mode = modeProp ?? (id ? "edit" : "add");

  const { userData } = useAuthStore();

  console.log("full uer data is : ", userData);

  const org = userData?.organization;

  const fetchTaskTypes = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${MAIN_URL}/api/project-management/project-task-type/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = res.data?.data;

      if (data) {
        setFormData({
          organization_id: data.organization_id || "",
          organization_entity_id: data.organization_entity_id || "",
          task_type_name: data.task_type_name || "",
          task_type_short_name: data.task_type_short_name || "",
          description: data.description || ""
        });
      }
    } catch (error) {
      toast.error("Failed to fetch task type data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if ((mode === "edit" || mode === "view") && id) {
      fetchTaskTypes();
    }
  }, [mode, id]);

  const [formData, setFormData] = useState({
    organization_id: org?.organization_id || "",
    organization_entity_id: "",
    task_type_name: "",
    task_type_short_name: "",
    description: ""
  });

  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const validateForm = () => {

    const errors = {};

    if (!formData.task_type_name) errors.task_type_name = "Task Type Name is required";
    if (formData.task_type_name.length > 150) errors.task_type_name = "Max 150 characters allowed";
    if (formData.task_type_short_name && formData.task_type_short_name.length > 20)
      errors.task_type_short_name = "Max 20 characters allowed";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };


  // Submit form
  const handleSubmit = async () => {
    setFormErrors({});

    if (!validateForm()) {
      toast.error("Please fix the validation errors.");
      return;
    }

    let organization_entity_id = userData?.organization?.
entities?.organization_entity_id || null;
    console.log("organization_entity_id is : ", organization_entity_id);


    setBtnLoading(true);
    try {
      const token = localStorage.getItem("token");


      if (mode === "edit") {
        await axios.put(`${MAIN_URL}/api/project-management/project-task-type/${id}`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Task Types updated");
      } else {
        await axios.post(`${MAIN_URL}/api/project-management/project-task-type`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Task Types added");
      }

      navigate("/project-task-type");
    } catch (err) {
      if (err.response?.status === 422) {toast.error("Please fix the validation errors.");
        setFormErrors(err.response.data.errors);
      } else {
        toast.error("Operation failed");
      }
    }
    setBtnLoading(false);
  };


  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };


  return (
    <Box px={4} py={4}>
      <Header
        mode={mode}
        updateMessage={" Task Type"}
        addMessage={" Task Type"}
        homeLink={"/project-type"}
        homeText={"Task Type"}
      />

      {loading ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>

                <TextField
                  fullWidth
                  disabled={mode === "view"}
                  name="task_type_name"
                  label="Task Type Name *"
                  value={formData.task_type_name}
                  onChange={handleChange}
                  error={!!formErrors.task_type_name}
                  helperText={formErrors.task_type_name}
                />

                <TextField
                  fullWidth
                  disabled={mode === "view"}
                  name="task_type_short_name"
                  label="Task Type Short Name "
                  value={formData.task_type_short_name}
                  onChange={handleChange}
                  error={!!formErrors.task_type_short_name}
                  helperText={formErrors.task_type_short_name}
                />

                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  disabled={mode === "view"}
                  label="Description "
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  error={!!formErrors.description}
                  helperText={formErrors.description}
                />

              </Grid>
              {mode !== "view" && (
              <Button
                variant="contained"
                color="primary"
                size="medium"
                onClick={handleSubmit}
                disabled={loading || btnLoading}
                sx={{
                  borderRadius: 2,
                  minWidth: 120,
                  textTransform: "capitalize",
                  fontWeight: 500,
                  mt: 2
                }}
              >
                {loading || btnLoading ? (
                  <CircularProgress size={22} sx={{ color: "#fff" }} />
                ) : mode === "edit" ? (
                  "Update"
                ) : (
                  "Submit"
                )}
              </Button>
              )}

            </Paper>
          </Grid>
        </Grid>
      )}

    </Box>
  )
}

export default ProjectTaskTypeForm